<!-- <nav class="pp-wrapper" role="navigation" aria-label="Page progress">
  <button class="visually-hidden" (click)="prev()" [disabled]="currentPage<=1">Previous</button>

  <ul class="pp-list">
    <li *ngFor="let _ of pages; let i = index" class="pp-item">
      <button
        type="button"
        class="pp-node"
        [class.active]="isActive(i+1)"
        [class.completed]="isCompleted(i+1)"
        [attr.aria-current]="isActive(i+1) ? 'step' : null"
        [attr.aria-label]="'Go to step ' + (i+1)"
        (click)="setPage(i+1)"
      >
        <span class="pp-number">{{i+1}}</span>
      </button>

      <div *ngIf="i < pages.length - 1" class="pp-connector" [class.active]="isCompleted(i+1)"></div>
    </li>
  </ul>

  <button class="visually-hidden" (click)="next()" [disabled]="currentPage>=totalPages">Next</button>
</nav> -->

<div class="progress">
  <div class="progress-container">
    <!-- Grey background line -->
    <div class="progress-line-bg"></div>

    <!-- Green animated line -->
    <div class="progress-line" #progressLine></div>
    <!-- (click)="goToStep(i + 1)" -->
    <div class="step" *ngFor="let step of steps; let i = index" [class.first-step]="i === 0" [class.active]="i < currentPage">
      <span>{{ step }}</span>
      <div class="circle">{{ i + 1 }}</div>
    </div>
  </div>
</div>
